import { useSelector } from 'react-redux';

import {
  getChangePlanReasonAfterConfirmEvent,
  getKnmDataErknmIsPlanned,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejected,
  getKnmIsErknmStatusTypeWaitingCarryOut,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const useIsErknmRequirementsEnabled = () => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const isKnmStatusRejected = useSelector(getKnmIsErknmStatusRejected);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isKnmStatusTypeWaitingCarryOut = useSelector(getKnmIsErknmStatusTypeWaitingCarryOut);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.REQUIREMENTS);
  const changePlanReasonAfterConfirm = useSelector(getChangePlanReasonAfterConfirmEvent);
  const isPlanned = useSelector(getKnmDataErknmIsPlanned);

  const isCheckForRsnChngPpXXI = changePlanReasonAfterConfirm?.some(
    item => item?.reasonChangeType?.code === 'RSN_CHNG_PP_XXI' || item?.reasonChangeType?.code === 'RSN_CHNG_PP_XX',
  );
  const isCheckForRsnChngPpXXII = changePlanReasonAfterConfirm?.some(
    item => item?.reasonChangeType?.code === 'RSN_CHNG_PP_XXII',
  );

  return (
    !isCommonWatchOnly &&
    isSupervisor &&
    (isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isEditableInStatusCommentsExist ||
      (isKnmStatusRejected && isKnmPlanStatusConsidered) ||
      (isKnmStatusCommentsExist && isKnmPlanStatusConsidered && isRemarksExists) ||
      (isKnmStatusTypeWaitingCarryOut && isPlanned && isCheckForRsnChngPpXXI) ||
      (isKnmStatusTypeWaitingCarryOut && isPlanned && isCheckForRsnChngPpXXII))
  );
};
